import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { requestInterface } from 'src/app/util/interfaces/request';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RequestPageExtraOptionsService {
	private readonly http = inject(HttpClient);
	private readonly authLoginService = inject(AuthLoginService);

	private cloneRequestUrl = environment.baseApiUrl + 'request';

	constructor() {}

	duplyRequest(requestToCopy: requestInterface): Observable<JSON> {
		const body: any = { summary: requestToCopy.summary, description: requestToCopy.description };
		body.idEnduser = requestToCopy.id_enduser;
		if (requestToCopy.id_solution_area && requestToCopy.id_solution_area !== '' && requestToCopy.topic && requestToCopy.topic !== '') {
			body.idSolutionArea = requestToCopy.id_solution_area;
			body.idTopic = requestToCopy.id_topic;
		}

		return this.http.post<JSON>(this.cloneRequestUrl, body, { headers: this.authLoginService.getHttpHeaders() });
	}
}
